import { stylesFieldForms } from '../styles'

export function formularioRegraIO() {
  return {
    styles: stylesFieldForms
  }
}
export type FormularioRegraIO = ReturnType<typeof formularioRegraIO>
